import _ from "underscore";

export const parseMessage = message => {
  const text = message.parts
    .flatMap(part => {
      if (part.partType === "inline" && part.payload.type === "text/plain") {
        return part.payload.content;
      }
      return [];
    })
    .join("");
  return { ...message, text, sender: message.sender || {} };
};

export const regexEscape = str => (str ? str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&") : null); // eslint-disable-line

export const searchCompare = (str = "", query) =>
  !query || str.toLowerCase().match(new RegExp(`\\b${regexEscape(query.toLowerCase())}`));

export const makeRoomNameFromPoolId = (oid, poolId) => `${oid}:POOL:${poolId}`;

export const getPoolIdFromRoomName = (oid, roomName = "") => {
  if (!oid || !roomName) return;
  if (isDM(roomName)) return;
  return roomName.replace(new RegExp(`${oid}:POOL:`), "");
};

export const getUserTotalFromRoom = (userIds = []) => userIds.filter(i => i !== "super").length;

export const isPoolRoom = (roomName = "") => roomName.includes(":POOL:");

export const getVMSPoolIdListFromRooms = (oid, roomList = []) => {
  if (!roomList.length || !oid) return;
  return roomList.filter(room => isPoolRoom(room.name)).map(room => getPoolIdFromRoomName(oid, room.name));
};
export const isDM = (roomName = "") => roomName.includes(":DM:");

export const getUserIdsFromRoomName = (oid, roomName = "") => {
  if (!oid || !roomName) return [];
  if (!isDM(roomName)) return [];
  const user_ids = roomName.replace(new RegExp(`${oid}:DM:`), "").split(":");

  return user_ids;
};
export const getUserIdFromRoomName = (oid, roomName = "", currentUserId) => {
  const ids = getUserIdsFromRoomName(oid, roomName);
  return ids.find(i => parseInt(i, 10) !== parseInt(currentUserId, 10));
};

export const getUserIdsFromDMList = (oid, roomList = [], currentUserId) => {
  const user_ids = roomList.filter(room => isDM(room.name)).flatMap(room => getUserIdsFromRoomName(oid, room.name));
  // eslint-disable-next-line eqeqeq
  return currentUserId ? user_ids.filter(id => id != currentUserId) : user_ids;
};

export const makeChatKitUserId = (oid, userId) => `${oid}:${userId}`;

export const getETUserIDFromChatKitUser = (oid, chatKitUserId) => {
  if (!oid || !chatKitUserId) return;
  if (typeof chatKitUserId !== "string") {
    return;
  }
  return chatKitUserId.replace(new RegExp(`${oid}:`), "");
};
